import React, { useEffect, useState } from "react";
import {
  BODHI_LOGIN,
  callNonStoreApi,
  handleDownloadCSV,
  isArrayNullOrUndefined,
  isNullOrUndefined,
} from "../utils/utils";
import {
  GetGrowezyClientList,
  GetGrowezyClientMetrics,
} from "../utils/ApiEndpoints";
import Loading from "./Loading";
import { useDispatch, useSelector } from "react-redux";
import {
  setClientListAction,
  setClientMetricsAction,
} from "../Store/appTempSlice";
import TableHeaderStrip from "./TableHeaderStrip";
import ClientRow from "./ClientRow";
import { Button, Checkbox, CircularProgress, Drawer } from "@mui/material";
import { AddFlex, CustomText, Gap } from "./reusableStyles";
import MetricsRow from "./MetricsRow";
import { Campaign, Refresh, Sort } from "@mui/icons-material";
import FilterListIcon from "@mui/icons-material/FilterList";
import useDialogActions from "../useDialogActions";
import FilterDrawerComponent from "./FilterDrawerComponent";
import BroadcastDrawerComponent from "./BroadcastDrawerComponent";

export const FILTER_PARAMETRS = {
  new: {
    type: "new",
    revenue: 0,
    published: 0,
    unpublished: 0,
  },
  inactive: {
    type: "inactive",
    revenue: 0,
    published: 0,
    unpublished: 1,
  },
  revenueBooster: {
    type: "revenueBooster",
    revenue: 0,
    published: 1,
    unpublished: 0,
  },
};

function Dashboard() {
  /***
   * Username
   * Onboarding Date
   * Distributor
   * Client Net revenue
   * Growezy Commission
   * Growezy Net Revenue.
   * Subscription Plan Charge
   * Payment Gateway
   */
  const [loading, setLoading] = useState(true);
  const [clients, setClients] = useState([]);
  const [isShowingOnlyBodhiClients, setIsShowingOnlyBodhiClients] =
    useState(false);
  const [filters, setFilters] = useState(null);
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.appTemp);

  const getHeaderList = () => {
    return [
      ["2%", "SL.No"],
      ["10%", "Username"],
      ["5%", "Created On"],
      ["10%", "Zero revenue (P/ U)"],
      ["10%", "Revenue (P / Total Revenue)"],
      ["5%", "Net Revenue"],
      // ["6%", "Commission"],
      // ["6%", "Covenience"],
      // ["5%", "Client revenue"],
      // ["5%", "Settled"],
      // ["5%", "Pending"],
      // ["5%", "Commission"],
    ];
  };

  const getBodhiTotal = (data) => {
    return data?.filter((element) => element.domain === BODHI_LOGIN).length;
  };

  const handleGetClientList = async (force) => {
    if (!force && !isNullOrUndefined(data.growezyClientMetrics)) {
      setLoading(false);
      setClients(data.growezyClientMetrics);
      return;
    }
    setLoading(true);
    const res = await callNonStoreApi(GetGrowezyClientMetrics);
    setClients(res.data.response);
    dispatch(setClientMetricsAction(res.data.response));
    showOnlyBodhiClients(isShowingOnlyBodhiClients);
    setLoading(false);
  };

  const showOnlyBodhiClients = (_flag) => {
    if (isArrayNullOrUndefined(data.growezyClientMetrics)) {
      return;
    }
    let clients;
    if (_flag) {
      clients = data.growezyClientMetrics.filter(
        (data) => data.domain === "coachlogin.bodhischoolofyoga.com"
      );
    } else {
      clients = data.growezyClientMetrics;
    }
    setClients(clients);
  };

  const ExportClientDataToCSV = async () => {
    const data = clients?.map((client) => {
      return {
        username: client.userName,
        email: client.userEmail,
        website: `${client.userName}.growezy.club`,
        number: client?.UserAdditionalDetails.userPhoneNumber?.replaceAll(
          " ",
          ""
        ),
      };
    });
    await handleDownloadCSV(data, true);
    return;
  };

  const handleSetFilters = (filterType) => {
    if (isNullOrUndefined(filterType)) {
      setClients(data.growezyClientMetrics);
      setFilters(null);
      setIsShowingOnlyBodhiClients(false);
      return;
    }
    // const filters = FILTER_PARAMETRS[filterType];
    const newClients = data.growezyClientMetrics.filter((data) => {
      switch (filterType) {
        case "new":
          return (
            data.publishedStats.total === 0 &&
            data.clientRevenue === 0 &&
            data.unpublishedStats.total === 0
          );
        case "inactive": {
          return (
            data.publishedStats.total === 0 &&
            data.clientRevenue === 0 &&
            data.unpublishedStats.total >= 1
          );
        }
        case "revenueBooster": {
          return data.publishedStats.total >= 1 && data.clientRevenue === 0;
        }
      }
    });
    if (isShowingOnlyBodhiClients) {
      setClients(
        newClients.filter(
          (data) => data.domain === "coachlogin.bodhischoolofyoga.com"
        )
      );
    } else {
      setClients(newClients);
    }
    setFilters(FILTER_PARAMETRS[filterType]);
  };

  useEffect(() => {
    handleGetClientList();
  }, []);

  return (
    <AddFlex flexDirection="column" padding="48px 38px">
      <AddFlex alignItems="center" gap="10px">
        <AddFlex gap="5px" flexDirection="column">
          <CustomText fontSize="16px" color="#020817">
            Bodhi Clients : {getBodhiTotal(data.growezyClientMetrics)}
          </CustomText>
          <AddFlex gap="5px" alignItems="center">
            <Checkbox
              checked={isShowingOnlyBodhiClients}
              onChange={(e) => {
                setIsShowingOnlyBodhiClients((prev) => !prev);
                showOnlyBodhiClients(e.target.checked);
              }}
              sx={{ padding: 0 }}
            />
            <CustomText color="black">Show only bodhi clients</CustomText>
          </AddFlex>
        </AddFlex>
        <Gap />

        <Button variant="contained" onClick={ExportClientDataToCSV}>
          Export
        </Button>
        <AddFlex
          onClick={() => handleGetClientList(true)}
          style={{ backgroundColor: "#ececec", cursor: "pointer" }}
          padding="10px"
          borderRadius="4px"
        >
          <Refresh sx={{ fontSize: "18px" }} />
        </AddFlex>
        <DialogIcon
          icon={<Campaign sx={{ cursor: "pointer", fontSize: "18px" }} />}
          dialogComponent={
            <BroadcastDrawerComponent
              numbers={clients
                ?.map((client) => client?.UserAdditionalDetails.userPhoneNumber)
                .filter((item) => !isNullOrUndefined(item))}
            />
          }
        />
        <DialogIcon
          icon={<FilterListIcon sx={{ cursor: "pointer", fontSize: "18px" }} />}
          dialogComponent={
            <FilterDrawerComponent
              setFilters={handleSetFilters}
              filters={filters}
            />
          }
        />
      </AddFlex>
      {loading ? (
        <>
          <AddFlex padding="48px" alignItems="center" justify="center">
            <Loading />
          </AddFlex>
        </>
      ) : (
        <>
          <TableHeaderStrip list={getHeaderList()} showCheckbox={false} />
          {clients?.map((client, index) => (
            <MetricsRow
              client={client}
              index={index}
              headerList={getHeaderList()}
            />
          ))}
        </>
      )}
    </AddFlex>
  );
}

export default Dashboard;

const DialogIcon = ({ icon, dialogComponent }) => {
  const { isDialogOpen, openDialog, closeDialog } = useDialogActions();
  return (
    <>
      <AddFlex
        style={{ backgroundColor: "#ececec", cursor: "pointer" }}
        padding="10px"
        borderRadius="4px"
        onClick={openDialog}
      >
        {icon}
      </AddFlex>
      <Drawer
        open={isDialogOpen}
        onClose={closeDialog}
        anchor="right"
        PaperProps={{
          sx: {
            width: "40vw",
          },
        }}
      >
        {React.cloneElement(dialogComponent, {
          ...dialogComponent.props,
          closeDialog: closeDialog,
        })}
      </Drawer>
    </>
  );
};
